import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from "antd";

import { actions } from "store";
import { ProfileForm, ProfileList } from "components/blocks/Profile";
import { SitePageForm } from 'components/blocks/Site';


class ProfileListScreen extends Component {
  showForm = (item = null) => {
    const { actions } = this.props;
    actions.profileShowEditForm({ show: true, object: item });
  };

  render() {
    const { site, history } = this.props;
    const detail = site.detail;

    return (
      <Fragment>
        <div className="page-content page-content-full">
          <div className="page-block page-block-full">
            {detail &&
            <ProfileList
              history={history}
              activeFilter={{ site: detail.id }}
              topActions={[
                <Button type="primary" className="" icon="plus" onClick={() => this.showForm()}>
                  Добавить анкету
                </Button>
              ]}
            />}
          </div>
        </div>

        {detail &&
        <ProfileForm siteId={detail.id}/>}

        {detail &&
        <SitePageForm siteId={detail.id}/>}
      </Fragment>
    );
  }
}


function mapStateToProps(state) {
  return {
    site: state.site,
    profile: state.profile,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.profile), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileListScreen);
